import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getAccordianHeaderStyle = (props, showTooltipRight, showTooltipLeft, showRightPadding) => {
  var showAccordian = props.showAccordian,
    _props$noHorizontalSp = props.noHorizontalSpacing,
    noHorizontalSpacing = _props$noHorizontalSp === void 0 ? false : _props$noHorizontalSp,
    showDivider = props.showDivider;
  var subTextWrapperRightPadding = showTooltipRight ? tokens.spacing.SPACING_28 : tokens.spacing.SPACING_14;
  return StyleSheet.create({
    singleContainerWrapper: Object.assign({
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'flex-start',
      paddingTop: showAccordian ? tokens.spacing.SPACING_0 : !showDivider && tokens.spacing.SPACING_20,
      paddingRight: showRightPadding ? showAccordian || showTooltipRight ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_12 : tokens.spacing.SPACING_0
    }, !noHorizontalSpacing && {
      marginHorizontal: tokens.spacing.SPACING_16
    }),
    subTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      paddingRight: showRightPadding ? subTextWrapperRightPadding : tokens.spacing.SPACING_0
    },
    singleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'flex-start'
    },
    singleContainerWrapperInternal: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      overflow: 'visible'
    },
    singleItemComponent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
      flexBasis: 'auto'
    },
    singleItemRightText: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      maxWidth: '100%',
      paddingRight: showRightPadding ? showTooltipRight && !showAccordian ? tokens.spacing.SPACING_8 : !showTooltipRight && !showAccordian ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_0 : tokens.spacing.SPACING_0
    },
    singleItemLeftText: {
      maxWidth: '100%',
      paddingRight: showTooltipLeft ? tokens.spacing.SPACING_4 : tokens.spacing.SPACING_0
    },
    toolTipStyle: {
      marginHorizontal: tokens.spacing.SPACING_2
    },
    toolTipLeftStyle: {
      marginLeft: tokens.spacing.SPACING_4
    },
    infoTagWrapperStyle: {
      paddingRight: tokens.spacing.SPACING_14,
      paddingVertical: tokens.spacing.SPACING_4
    },
    singleElementWrapperLeft: {
      flex: 1,
      flexBasis: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    },
    singleElementWrapperRight: {
      flex: 1,
      flexBasis: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    },
    leftComponentWrapper: {
      flex: 1,
      flexBasis: 'auto',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginRight: tokens.spacing.SPACING_8
    },
    rightComponentWrapper: {
      flex: 1,
      flexBasis: 'auto',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      maxWidth: '50%'
    }
  });
};